<template>
  <div>
    <div style="width:100%; height: 439px;" class="slid">
      <img src="../assets/images/slide1.png" style="height: 350px;">
    </div>

  <div>
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="6">
        <div class="block_left" >
            <img src="../assets/images/pavilion.png" style="height: 398;">
        </div>
      </el-col>

      <el-col class="block_right">
        <div v-for="pavilion in pavilions" :key="pavilion.name">
          <div class="subscript1">
            <img class = "subscript_img" :src="pavilion.icon" >
            <span class="subscript1">{{ pavilion.number }}</span>
            <span class="subscript2">{{ pavilion.name }}</span>
            </div>
        </div>
      </el-col>
  </el-row>
  </div>

    <div>
      <el-row justify="center">
      <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
      <el-radio-button :label="false" style="height: 10">{{$t('Default')}}</el-radio-button>
      <el-radio-button :label="true">{{$t('Latest')}}</el-radio-button>
      </el-radio-group>
      <el-button style="width: 132px;
        height: 30px;
        background: #FFFFFF;
        border: 1px solid #DDDDDD;
        float:right">
        默认按钮</el-button>
      </el-row>
    </div>

   
    <div>
      <el-row type="flex" class="company-bg" justify="center">
      <el-card>
          <el-row :span="5" v-for="company_info in company_infos" :key="company_info.id" type="flex">
            <img :src="company_info.icon" class="company_image">
              <el-col>
                <div style="padding: 14px;">
                  <img :src="company_info.logo">
                </div>
                <div style="padding: 14px;">
                  <span>{{company_info.name}}</span>
                </div>
                <div style="padding: 14px;">
                  <span>{{company_info.info}}</span>
                </div>
                <el-row :span="8" type="flex">
                  <div class="bottom clearfix">
                    <el-button v-if="false" type="success">{{$t("Send Massage")}}</el-button>
                  </div>
                  <div class="bottom_order">
                    <el-button>{{$t("Reservation")}}</el-button>
                  </div>
                  <div class="bottom_collection">
                    <el-button>{{$t("Favorite")}}</el-button>
                  </div>
                </el-row>
            </el-col>
          </el-row>
      </el-card>
      </el-row>
    </div>

    <div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      pager-count = 3
      page-size = 8
    >
  </el-pagination>
  </div>
  </div>
</template>

<script>

export default {
    data() {
      return {
        isCollapse: true,
        total: 10,
        pavilions: [
          {
            name: "国际品牌馆",
            number: "W1",
            icon: "https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
          }
          ],

        company_infos: [
        {
          logo: '',
          id: 1,
          info: "公司所在馆：E1主营范围：整车 | 整车",
          name: "捷安特（昆山）有限公司",
          icon: "https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
        }
        ]
      };
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  //created: {}
};

</script>
<style lang='less' scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
   width: 28px;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 12px;
  }
  .location_img {
    flex: left;
    text-align: center;
  }

  .block_right {
    background: #333333;
    text-align: center;
    width: 730px;
    height: 398;
  }

  .block_left {
    height: 398;
     width: 470px;
  }
  .row-bg {
    text-align: center;
  }
  .subscript1 {
    width: 42px;
    height: 24px;
    font-size: 28px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }

  .subscript2 {
    width: 80px;
    height: 16px;
    font-size: 16px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
  .img_sub {

  }
  .bottom_order .bottom_collection {
    width: 63px;
    height: 46px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
  }
</style>


// WEBPACK FOOTER //
// src/components/notFound.vue